import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex-shrink-0"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "flex-shrink-0"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  class: "flex-shrink-0"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "text-sm font-medium" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_12 = [
  _hoisted_11
]

import { computed, PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: "",
  },
  type: {
    type: String as PropType<"success" | "error" | "info">,
    default: "info",
  },
},
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (e: "close"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const toastClass = computed(() => {
  const classes = {
    success: "bg-green-600 text-white",
    error: "bg-red-600 text-white",
    info: "bg-primary-800 text-white",
  };
  return classes[props.type];
});

const close = () => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-300",
      "enter-from-class": "translate-y-4 opacity-0",
      "enter-to-class": "translate-y-0 opacity-100",
      "leave-active-class": "transition ease-in duration-200",
      "leave-from-class": "translate-y-0 opacity-100",
      "leave-to-class": "translate-y-4 opacity-0"
    }, {
      default: _withCtx(() => [
        (__props.visible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["fixed bottom-20 left-1/2 -translate-x-1/2 z-50 px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 max-w-sm", _unref(toastClass)])
            }, [
              (__props.type === 'success')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
                : (__props.type === 'error')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9)),
              _createElementVNode("p", _hoisted_10, _toDisplayString(__props.message), 1),
              _createElementVNode("button", {
                onClick: close,
                class: "ml-2 flex-shrink-0 opacity-70 hover:opacity-100 transition-opacity"
              }, _hoisted_12)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})